module.exports = __webpack_public_path__ + "img/filter-button1.fed029ac.svg";